import type { OrderItemsReplacements } from '@fourthwall/services/dist/OrderApiClient'

import type { EditableOffer } from '../OrderEdit.types'
import { addExistingItemQuantity } from './addExistingItemQuantity'

export const getReplacementsPayload = (
  editableOffers?: EditableOffer[],
): OrderItemsReplacements[] => {
  if (!editableOffers) {
    return []
  }

  return editableOffers
    .filter((editableOffer) => editableOffer.original.variantId !== editableOffer.current.variantId)
    .map((editableOffer) => ({
      from: editableOffer.original.variantId,
      to: editableOffer.current.variantId,
      quantity: editableOffer.current.quantity,
    }))
    .reduce((accumulator: OrderItemsReplacements[], currentReplacement) => {
      const existingReplacement = accumulator.find(
        (replacement) =>
          replacement.from === currentReplacement.from && replacement.to === currentReplacement.to,
      )
      if (existingReplacement) {
        return addExistingItemQuantity(accumulator, existingReplacement)
      }

      return [...accumulator, currentReplacement]
    }, [])
}
